module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b3ywb"))).then(() => parcelRequire('d0iPb'));